import { IERechnungsInfo, IOrderDetailsInfo, IVertragskonto, Product } from '@mwe/models';
import { isProductCategory, setInvoiceAccount } from '@mwe/utils';
import { ProductCategoryEnum } from '@mwe/constants';

export const checkIfRelocationIsAllowed = (products: Product[]): boolean => {
  if (!Array.isArray(products) || products.length <= 1) {
    return true;
  }

  const stromGasArray = products.filter(
    product =>
      isProductCategory(product.category, ProductCategoryEnum.STROM) || isProductCategory(product.category, ProductCategoryEnum.GAS),
  );

  const fernwaermeArray = products.filter(product => isProductCategory(product.category, ProductCategoryEnum.FERNWAERME));

  return isThereOnlyOneUniqueCustomer(stromGasArray) && isThereOnlyOneUniqueCustomer(fernwaermeArray);
};

export const isThereOnlyOneUniqueCustomer = (products: Product[]): boolean => {
  if (!Array.isArray(products) || products.length <= 1) {
    return true;
  }

  const customerNumbers = products.map(product => product.customerNumber);
  const uniqueCustomerNumbers = Array.from(new Set(customerNumbers));
  return uniqueCustomerNumbers.length === 1;
};

export const updateRelocationDetails = ({
  relocationDetails,
  invoiceData,
  eRechnungsInfo,
}: {
  relocationDetails: IOrderDetailsInfo[];
  invoiceData: IVertragskonto;
  eRechnungsInfo: IERechnungsInfo;
}): IOrderDetailsInfo[] => {
  const hasOrderDetails = Array.isArray(relocationDetails) && !!relocationDetails?.length;

  if (!hasOrderDetails) {
    return [];
  }

  if (!invoiceData && !hasOrderDetails) {
    return [];
  }

  if (!invoiceData) {
    return relocationDetails;
  }

  return relocationDetails.map(orderDetails => {
    if (orderDetails.status === 'Abmeldung') return orderDetails;

    const updatedOrder = setInvoiceAccount(
      {
        ...orderDetails,
        verrechnungskonto: {
          ...orderDetails.verrechnungskonto,
          eingangsZahlweg: invoiceData.zahlungsmethode,
          eingangskonto: {
            ...orderDetails.verrechnungskonto.eingangskonto,
            iban: invoiceData?.iban,
          },
        },
        eRechnungInfo: {
          ...orderDetails.eRechnungInfo,
          ...eRechnungsInfo,
        },
      },
      true,
      false,
    );

    return {
      ...updatedOrder,
    };
  });
};
